import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import PollVoteFullModel from "./PollVoteFullModel";

export default class PollsUserVotesModel {
  public meta: MetaModel = new MetaModel();
  public data: PollVoteFullModel[] = [];
}
